import React from "react";

import { Avatar, AvatarFallback } from "@/src/components/ui/avatar";
import { cn } from "@/src/lib/utils";

import type { JSX } from "react";

import type { StorageProviderKind } from "@/src/api/ProjectAPI.types";

const S3_STYLE = { label: "S3", className: "bg-orange-500/15 text-orange-500" };

const CONFIG: Record<
  StorageProviderKind,
  { label: string; className: string }
> = {
  s3: S3_STYLE,
  s3_compatible: S3_STYLE,
};

interface ProviderIconProps {
  provider: StorageProviderKind;
}

export default function ProviderIcon({
  provider,
}: ProviderIconProps): JSX.Element {
  const config = CONFIG[provider];

  return (
    <Avatar className="rounded-md" size="sm">
      <AvatarFallback
        className={cn("rounded-md text-xs font-semibold", config.className)}
      >
        {config.label}
      </AvatarFallback>
    </Avatar>
  );
}
